import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { Authorization } from '../models/authorization.model';
import { ConsultaLista } from '../models/consulta-lista.model';
import { Lista } from '../models/lista.model';
import { ExamenAutomatic } from '../models/examen-automatic.model';
import { ResponseAuthorizationAutomatic } from '../models/response-authorization-automatic.model';
import { VoucherRequest } from '../models/voucher-request.model';
import { VoucherAutomatic } from '../models/voucher-automatic.model';

@Injectable()
export class AuthorizationService {

    constructor(
        private http: HttpClient,
        private api: ApiConfig
    ) { }

    getAuthorizations(contrato: string, identificacion: string, idradicador: string): Observable<Array<Authorization>> {
        return this.http.get<Array<Authorization>>(this.api.url + '/vouchers/' + contrato + '/' + identificacion + '/' + idradicador);
    }

    getHomologacionTipoDocumento(documentType: string): Observable<Lista> {
        return this.http.get<Lista>(this.api.url + '/vouchers/documenttypehomologation/' + documentType);
    }

    postCreaAutorizacionAutomatica(codigoIps: string, document: string, documentType: string, authorizationRequest: VoucherRequest, automaticAuthorization: VoucherAutomatic): Observable<any> {
        return this.http.post<any>(this.api.url + '/vouchersauthomatic',{ codigoIps: codigoIps, documento: document, tipoDocumento: documentType, eAuthorizationRequestWrapper: authorizationRequest, eAuthomaticAuthorizationWrapper: automaticAuthorization });
    }

    postCreaAutorizacionManual(_formData : FormData) : Observable<any>{
        const _headers = {'enctype' : 'multipart/form-data'};
        return this.http.post<any>(this.api.url + '/vouchers/newmanual', _formData, { headers: _headers })
    }



}


// WEBPACK FOOTER //
// /app/src/app/shared/services/authorization.service.ts